"use strict";

exports.__esModule = true;
exports.useCurrentClassificationDevices = useCurrentClassificationDevices;
var _react = require("react");
var _CurrentClassificationContext = require("./CurrentClassificationContext");
/**
 * Register devices for shared current-classification subscriptions.
 * Returns the shared deviceStates map.
 */
function useCurrentClassificationDevices(deviceUuids) {
  if (deviceUuids === void 0) {
    deviceUuids = [];
  }
  var _useContext = (0, _react.useContext)(_CurrentClassificationContext.CurrentClassificationContext),
    deviceStates = _useContext.deviceStates,
    registerDevices = _useContext.registerDevices;
  var deviceUuidsKey = (deviceUuids || []).filter(Boolean).join(",");
  (0, _react.useEffect)(function () {
    var uuids = deviceUuidsKey ? deviceUuidsKey.split(",") : [];
    return registerDevices(uuids);
  }, [deviceUuidsKey, registerDevices]);
  return deviceStates;
}